import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { TableCellStyledWithActions } from '../../../../../components/list/TableComponentsStyled';

const RefineAuthorizationListActionCell = ({ documentState, dispatch, userGroups }) => {
  const { t } = useTranslation();

  const onCheckAll = (documentStateId, documentTypeId) => {
    dispatch({ type: 'OnRefineSetAll', documentStateId, documentTypeId, value: true, userGroups });
  };
  const onUncheckAll = (documentStateId, documentTypeId) => {
    dispatch({ type: 'OnRefineSetAll', documentStateId, documentTypeId, value: false, userGroups });
  };

  return (
    <TableCellStyledWithActions>
      <Toolbar>
        <IconButton
          fontSize='medium'
          size='small'
          color='primary'
          variant='text'
          tooltip={t('Authorization.CheckAllTooltip')}
          onClick={() => onCheckAll(documentState.documentStateId, documentState.documentTypeId)}
        >
          <CheckBox />
        </IconButton>
        <IconButton
          fontSize='medium'
          size='small'
          color='primary'
          variant='text'
          tooltip={t('Authorization.UncheckAllTooltip')}
          onClick={() => onUncheckAll(documentState.documentStateId, documentState.documentTypeId)}
        >
          <CheckBoxOutlineBlank />
        </IconButton>
      </Toolbar>
    </TableCellStyledWithActions>
  );
};

RefineAuthorizationListActionCell.propTypes = {
  documentState: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default RefineAuthorizationListActionCell;
